import { render, staticRenderFns } from "./ProductTileSlider.vue?vue&type=template&id=04752308&scoped=true&"
import script from "./ProductTileSlider.vue?vue&type=script&async=true&lang=js&"
export * from "./ProductTileSlider.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ProductTileSlider.vue?vue&type=style&index=0&id=04752308&lang=scss&scoped=true&"
import style1 from "./ProductTileSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04752308",
  null
  
)

export default component.exports